import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import GDPRClause from 'components/global/GDPRClause'
import StepHeading from 'components/global/StepHeading'
import Box from 'components/shared/Box'
import Agreements from 'routes/OrderAndPayment/sections/Agreements'
import ContactData from 'routes/OrderAndPayment/sections/ContactData'
import { pushDataLayer } from 'helpers/analytics'
import VouchersPlaceOrderSection from './VouchersPlaceOrderSection'
import VouchersDeliveryOptions from './VouchersDeliveryOptions'
import { useCart } from 'store/cart-slice/hooks'

const VouchersOrderAndPayment = () => {
    const { formatMessage } = useIntl()
    const { isCartEmpty } = useCart()

    useEffect(() => {
        // < analytics
        pushDataLayer({
            event: 'funnelStep',
            event_category: 'vouchers',
            event_action: 'checkout_form_presented',
            event_label: '',
        })
        // analytics >
    }, [isCartEmpty])

    return (
        <Box gap={[16, 24]} align="stretch">
            <StepHeading
                title={formatMessage({
                    id: 'global.steps.caption_order',
                    defaultMessage: 'Zamówienie i płatność',
                })}
            />
            <VouchersDeliveryOptions />
            <ContactData />
            <Agreements />
            <VouchersPlaceOrderSection />
            <GDPRClause />
        </Box>
    )
}

export default VouchersOrderAndPayment
